import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'
import { CreateDiagnosisPayload } from '@/services/create-diagnosis'

import { ImageCountMapper } from './image-count-mapper'
import { MappingDiagnosisMapper } from './mapping-diagnosis-mapper'
import { MosaicAdapter } from './mosaic-adapter'

export interface DiagnosisMapperProps {
  user: CreateDiagnosisPayload['user']
  selectedCompany: CreateDiagnosisPayload['company']
  registerData: DiagnosisRegistrationStoreData['registerData']
  polygonsData: DiagnosisRegistrationStoreData['polygonsData']
  selectFilesData: DiagnosisRegistrationStoreData['selectFilesData']
  physiologicalRegisterData: DiagnosisRegistrationStoreData['physiologicalRegisterData']
  plantingFailureData: DiagnosisRegistrationStoreData['plantingFailureData']

  mosaicAdapter: MosaicAdapter
  mappingIdMapper: MappingDiagnosisMapper
  imageCountMapper: ImageCountMapper
}

export class DiagnosisMapper {
  private user
  private selectedCompany
  private registerData
  private polygonsData
  private selectFilesData
  private physiologicalRegisterData
  private plantingFailureData

  private mosaicAdapter
  private mappingIdMapper
  private imageCountMapper

  constructor(props: DiagnosisMapperProps) {
    this.user = props.user
    this.selectedCompany = props.selectedCompany
    this.registerData = props.registerData
    this.polygonsData = props.polygonsData
    this.selectFilesData = props.selectFilesData
    this.physiologicalRegisterData = props.physiologicalRegisterData
    this.plantingFailureData = props.plantingFailureData

    this.mosaicAdapter = props.mosaicAdapter
    this.mappingIdMapper = props.mappingIdMapper
    this.imageCountMapper = props.imageCountMapper
  }

  build(): CreateDiagnosisPayload {
    const imageCount = this.imageCountMapper.getImageCount()

    return {
      mosaic: this.mosaicAdapter.build(),
      mapping_id: this.mappingIdMapper.build(),
      demand_name: this.registerData!.demand_name,
      project: {
        id: this.registerData!.project.id,
        name: this.registerData!.project.name,
        region_id: this.registerData!.region?.id,
      },
      fields: this.polygonsData || undefined,
      flight_date: this.registerData!.flight_date,
      input_image_type: this.registerData!.image_type,
      company: {
        id: this.selectedCompany.id,
        name: this.selectedCompany.name,
      },
      user: {
        id: this.user.id,
        name: this.user.name,
        email: this.user.email,
      },
      perimeter: {
        area: this.selectFilesData!.perimeter.results.area,
        lat_long: this.selectFilesData!.perimeter.results.lat_long,
      },
      flight_info: this.physiologicalRegisterData || undefined,
      image_count: imageCount || undefined,
      culture: this.registerData!.culture,
      treatment: this.registerData!.treatment,
      planting_type: this.plantingFailureData?.planting_type,
      planting_space: this.plantingFailureData?.planting_space,
      cane_cycle_type: this.plantingFailureData?.cane_cycle_type,
    }
  }
}
